import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { IconButton, Input, InputAdornment, Menu, MenuItem, Select, TableSortLabel } from '@material-ui/core';
import MenuIcon from 'mdi-react/MenuIcon';
import ArrowDownIcon from 'mdi-react/ArrowDownIcon';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { Clear, DateRangeOutlined, ArrowUpward, ArrowDownward } from '@material-ui/icons';
import { KeyboardDatePicker } from '@material-ui/pickers';
import classnames from 'classnames';
import isArray from 'lodash/isArray';
import Autocomplete from '../reactive-form/autocomplete';

var GridHead =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridHead, _React$Component);

  function GridHead(props) {
    var _this;

    _classCallCheck(this, GridHead);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridHead).call(this, props));
    _this.buttonPress = false;
    /**
     * Смена сортировки
     * @param field
     * @param direction
     */

    _this.onChangeOrder = function (field, direction) {
      return function () {
        var _this$props = _this.props,
            multipleOrder = _this$props.multipleOrder,
            onChangeOrder = _this$props.onChangeOrder;
        var order = _this.state.order;
        var findOrderField = order.findIndex(function (item) {
          return item.field === field;
        });

        if (findOrderField >= 0) {
          if (direction) {
            order[findOrderField].direction = direction;
          } else {
            var directionField = order[findOrderField].direction;

            if (directionField === 'desc') {
              order[findOrderField].direction = 'asc';
            } else if (directionField === 'asc') {
              order.splice(findOrderField, 1);
            }
          }
        } else {
          if (multipleOrder) {
            order.push({
              field: field,
              direction: direction || 'desc'
            });
          } else {
            order = [{
              field: field,
              direction: direction || 'desc'
            }];
          }
        }

        _this.setState({
          order: order
        }, function () {
          onChangeOrder(order);
        });
      };
    };
    /**
     * Отображение текущей сортировки у колонки
     * @param field
     */


    _this.getDirection = function (field) {
      var order = _this.state.order;

      if (Array.isArray(order)) {
        var findOrderField = order.findIndex(function (item) {
          return item.field === field;
        });

        if (findOrderField >= 0) {
          return {
            active: true,
            direction: order[findOrderField].direction
          };
        }
      }

      return {
        active: false,
        direction: undefined
      };
    };

    _this.openColumnMenu = function (field) {
      return function (event) {
        var _this$props2 = _this.props,
            columnMenu = _this$props2.columnMenu,
            onToggleColumnMenu = _this$props2.onToggleColumnMenu;
        columnMenu[field] = event.currentTarget;
        onToggleColumnMenu(columnMenu);
      };
    };

    _this.closeColumnMenu = function (field) {
      return function () {
        var _this$props3 = _this.props,
            columnMenu = _this$props3.columnMenu,
            onToggleColumnMenu = _this$props3.onToggleColumnMenu;
        columnMenu[field] = null;
        onToggleColumnMenu(columnMenu);
      };
    };
    /**
     * Начала перетаскивания колонки
     * @param index
     */


    _this.onDragColumnStart = function (index) {
      return function (event) {
        event.dataTransfer.effectAllowed = 'copyMove';
        _this.dragOrderIndex = index;

        if (event.currentTarget.parentElement && event.currentTarget.parentElement.parentElement) {
          event.currentTarget.parentElement.parentElement.classList.add(_this.props.classes.onDrag);
        }

        event.currentTarget.classList.add(_this.props.classes.columnMove);
      };
    };
    /**
     * Окончание перетаскивания колонки
     * @param event
     */


    _this.onDragColumnEnd = function (event) {
      event.currentTarget.closest('tr').classList.remove(_this.props.classes.onDrag);
      event.currentTarget.classList.remove(_this.props.classes.columnMove);
    };
    /**
     * @param event
     */


    _this.onDragOver = function (event) {
      event.preventDefault();
    };
    /**
     * По окончанию перетаскивания передаем наверх индексы
     * @param index
     */


    _this.onDrop = function (index) {
      return function (event) {
        if (_this.dragOrderIndex !== undefined) {
          _this.props.onSortable(_this.dragOrderIndex, index);

          event.currentTarget.classList.remove(_this.props.classes.dragTo);
          _this.dragOrderIndex = undefined;
          event.preventDefault();
        }
      };
    };
    /**
     * Начало изменения ширины колонки
     * @param field
     * @param width
     */


    _this.onResizeStart = function (field, width) {
      return function (event) {
        _this.buttonPress = true;
        _this.currentField = field;
        _this.currentWidth = width;
        _this.currentX = event.clientX;
        document.body.style.pointerEvents = 'none';
        document.body.style.userSelect = 'none';
      };
    };

    _this.renderOrderIcon = function (direction) {
      var slim = _this.props.slim;

      if (direction === 'desc') {
        return React.createElement(ArrowDownward, {
          fontSize: slim ? 'small' : 'default'
        });
      } else if (direction === 'asc') {
        return React.createElement(ArrowUpward, {
          fontSize: slim ? 'small' : 'default'
        });
      } else {
        return null;
      }
    };

    _this.renderHeadTitle = function () {
      var _this$props4 = _this.props,
          columns = _this$props4.columns,
          classes = _this$props4.classes,
          actions = _this$props4.actions,
          getStyleCellWidth = _this$props4.getStyleCellWidth,
          getStyleActionCellWidth = _this$props4.getStyleActionCellWidth,
          columnMenu = _this$props4.columnMenu,
          isDropDown = _this$props4.isDropDown,
          orderless = _this$props4.orderless,
          slim = _this$props4.slim;
      return React.createElement("tr", null, isDropDown && React.createElement("td", {
        className: classnames(classes.td, classes.dropDownTd)
      }, "\xA0"), columns.map(function (column, index) {
        if (column.hide) return null;

        var _this$getDirection = _this.getDirection(column.field),
            active = _this$getDirection.active,
            direction = _this$getDirection.direction;

        return React.createElement("td", {
          key: "head-cell-".concat(column.field),
          className: "".concat(classes.td, " ").concat(classes.tdHead),
          style: getStyleCellWidth(column),
          onDragOver: _this.onDragOver,
          onDrop: _this.onDrop(index)
        }, React.createElement("div", {
          className: classnames(classes.cellHead, _defineProperty({}, classes.cellHeadSlim, slim)),
          draggable: true,
          onDragStart: _this.onDragColumnStart(index),
          onDragEnd: _this.onDragColumnEnd
        }, orderless || column.order === false ? React.createElement("span", {
          className: classes.cellHeadSortLabel
        }, column.label) : React.createElement(TableSortLabel, {
          active: active,
          direction: direction,
          onClick: _this.onChangeOrder(column.field),
          className: classes.cellHeadSortLabel,
          classes: {
            root: classes.cellHeadSortableIcon,
            icon: classes.cellHeadIcon
          },
          IconComponent: function IconComponent() {
            return _this.renderOrderIcon(direction);
          }
        }, column.label), React.createElement(IconButton, {
          onClick: _this.openColumnMenu(column.field),
          size: 'small',
          className: classes.cellHeadIcon,
          disabled: orderless || column.order === false
        }, React.createElement(MenuIcon, {
          size: 18
        })), React.createElement(Menu, {
          anchorEl: columnMenu[column.field],
          open: Boolean(columnMenu[column.field]),
          onClose: _this.closeColumnMenu(column.field),
          onClick: _this.closeColumnMenu(column.field),
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
          },
          className: classes.columnMenu
        }, React.createElement(MenuItem, {
          dense: true,
          onClick: _this.onChangeOrder(column.field, 'desc'),
          className: classes.columnMenuItem
        }, React.createElement(ArrowDownIcon, {
          size: 14,
          className: classes.columnMenuItemIcon
        }), " \u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E"), React.createElement(MenuItem, {
          dense: true,
          onClick: _this.onChangeOrder(column.field, 'asc'),
          className: classes.columnMenuItem
        }, React.createElement(ArrowUpIcon, {
          size: 14,
          className: classes.columnMenuItemIcon
        }), " \u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E"))), React.createElement("div", {
          className: classes.resize,
          onMouseDown: _this.onResizeStart(column.field, column.width)
        }));
      }), !!actions.length && React.createElement("td", {
        className: classnames(classes.td, _defineProperty({}, classes.tdSlim, slim)),
        style: getStyleActionCellWidth()
      }));
    };
    /**
     * on change input
     * @param column
     */


    _this.onChangeFilterValue = function (column) {
      return function (event) {
        var filter = cloneDeep(_this.state.filter);
        filter[column.field].value = event.target.value;

        _this.setState({
          filter: filter
        });
      };
    };
    /**
     * on change select
     * @param column
     */


    _this.onChangeSelectValue = function (column) {
      return function (event) {
        var filter = cloneDeep(_this.state.filter);

        if (isArray(event.target.value) && event.target.value.length === 0) {
          filter[column.field].value = undefined;
        } else {
          filter[column.field].value = event.target.value;
        }

        _this.setState({
          filter: filter
        }, function () {
          _this.updateFilters();

          _this.selectHide();
        });
      };
    };
    /**
     * on change react select
     * @param column
     * @param value
     */


    _this.onChangeReactSelect = function (column, value) {
      var filter = cloneDeep(_this.state.filter);
      filter[column.field].value = value;

      _this.setState({
        filter: filter
      }, function () {
        _this.updateFilters();

        _this.selectHide();
      });
    };
    /**
     * on change date
     * @param field
     * @param date
     */


    _this.onChangeDateValue = function (field, date) {
      var filter = cloneDeep(_this.state.filter);
      filter[field].value = date;

      _this.setState({
        filter: filter
      }, function () {
        if (date != 'Invalid Date') {
          _this.updateFilters();
        }
      });
    };
    /**
     * Записываем значение поля, для отслеживания изменения у поля
     */


    _this.onFocus = function (event) {
      _this.value = event.target.value;
    };
    /**
     * Если поле изменилось, обновляем состояние фильтров у грида
     */


    _this.onBlur = function (event) {
      if (_this.value !== event.target.value) {
        _this.updateFilters();
      }

      _this.value = undefined;
    };
    /**
     * По нажатию на Enter меняем значение фильтров
     * @param event
     */


    _this.onEnter = function (event) {
      if (event.charCode === 13) {
        // enter key pressed
        event.preventDefault();
        _this.value = event.target.value;

        _this.updateFilters();
      }
    };
    /**
     * Очистить значение фильтра
     * @param field
     */


    _this.onClear = function (field) {
      return function () {
        var filter = _this.state.filter;
        filter[field].value = '';

        _this.setState({
          filter: filter
        }, _this.updateFilters);
      };
    };

    _this.selectOpen = function (field) {
      _this.setState({
        selectOpen: field
      });
    };

    _this.selectHide = function () {
      _this.setState({
        selectOpen: undefined
      }, function () {
        console.log(_this.state.selectOpen);
      });
    };

    _this.renderHeadFilter = function () {
      var _this$props5 = _this.props,
          columns = _this$props5.columns,
          actions = _this$props5.actions,
          classes = _this$props5.classes,
          getStyleCellWidth = _this$props5.getStyleCellWidth,
          getStyleActionCellWidth = _this$props5.getStyleActionCellWidth,
          isDropDown = _this$props5.isDropDown,
          slim = _this$props5.slim;
      var filterLength = 0;
      return React.createElement("tr", null, isDropDown && React.createElement("td", {
        className: classnames(classes.td, classes.dropDownTd)
      }, "\xA0"), columns.map(function (column) {
        if (column.hide) return null;

        if (column.filterHide) {
          return React.createElement("td", {
            key: "filter-cell-".concat(column.field),
            className: classnames(classes.td, _defineProperty({}, classes.tdSlim, slim))
          }, "\xA0");
        }

        filterLength++;
        return React.createElement("td", {
          key: "filter-cell-".concat(column.field),
          className: classnames(classes.td, _defineProperty({}, classes.tdSlim, slim)),
          style: getStyleCellWidth(column)
        }, _this.renderCellFilter(column));
      }), !!filterLength && !!actions.length && React.createElement("td", {
        className: classnames(classes.td, _defineProperty({}, classes.tdSlim, slim)),
        style: getStyleActionCellWidth()
      }));
    };

    _this.state = {
      order: props.order || [],
      filter: props.filter,
      selectOpen: undefined
    };
    return _this;
  }

  _createClass(GridHead, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('mousemove', this.onResize.bind(this), false);
      window.addEventListener('mouseup', this.onResizeEnd.bind(this), false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.onResize.bind(this), false);
      window.removeEventListener('mouseup', this.onResizeEnd.bind(this), false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var filter = prevProps.filter,
          order = prevProps.order;
      var currentFilter = cloneDeep(this.props.filter);
      var currentOrder = cloneDeep(this.props.order);

      if (!isEqual(filter, currentFilter)) {
        this.setState({
          filter: currentFilter
        });
      }

      if (!isEqual(order, currentOrder)) {
        this.setState({
          order: Array.isArray(currentOrder) ? currentOrder.map(function (order) {
            return _objectSpread({}, order);
          }) : undefined
        });
      }
    }
    /**
     * Изменения ширины колонки
     * @param event
     */

  }, {
    key: "onResize",
    value: function onResize(event) {
      if (this.buttonPress && this.currentField) {
        this.props.onResizeColumnWidth(this.currentField, (this.currentWidth || 0) + (event.clientX - (this.currentX || 0)));
      }
    }
    /**
     * По окончанию изменения ширины колонки сохраняем
     */

  }, {
    key: "onResizeEnd",
    value: function onResizeEnd() {
      if (this.buttonPress) {
        this.buttonPress = false;
        this.currentField = undefined;
        this.currentWidth = undefined;
        this.currentX = undefined;
        this.props.onChangeSetting();
        document.body.style.pointerEvents = null;
        document.body.style.userSelect = null;
      }
    }
  }, {
    key: "updateFilters",
    value: function updateFilters() {
      var onChangeFilter = this.props.onChangeFilter;

      if (onChangeFilter) {
        var filter = this.state.filter;
        onChangeFilter(filter);
      }
    }
  }, {
    key: "renderCellFilter",
    value: function renderCellFilter(column) {
      var _this2 = this;

      var _this$props6 = this.props,
          classes = _this$props6.classes,
          slim = _this$props6.slim;
      var _this$state = this.state,
          filter = _this$state.filter,
          selectOpen = _this$state.selectOpen;
      var value = filter[column.field] ? filter[column.field].value : '';

      switch (column.type) {
        case 'date':
          return React.createElement("div", {
            className: classes.datepickerContainer
          }, React.createElement(KeyboardDatePicker, {
            autoOk: true,
            variant: 'inline',
            value: value || null,
            format: 'dd.MM.yyyy',
            onChange: function onChange(date) {
              return _this2.onChangeDateValue(column.field, date);
            },
            className: classnames(classes.datepicker, _defineProperty({}, classes.datepickerSlim, slim)),
            keyboardIcon: React.createElement(DateRangeOutlined, {
              fontSize: 'small'
            }),
            mask: '__.__.____',
            invalidDateMessage: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B",
            maxDateMessage: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u043C\u0435\u043D\u044C\u0448\u0435 31.12.2099",
            maxDate: new Date('2099-12-31'),
            minDateMessage: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u0431\u043E\u043B\u044C\u0448\u0435 01.01.1900",
            minDate: new Date('1900-01-01'),
            fullWidth: true
          }), !!value && React.createElement(IconButton, {
            onClick: this.onClear(column.field),
            className: classes.datepickerClear
          }, React.createElement(Clear, {
            fontSize: 'small'
          })));
          break;

        case 'year':
          return React.createElement("div", {
            className: classes.datepickerContainer
          }, React.createElement(KeyboardDatePicker, {
            autoOk: true,
            variant: 'inline',
            views: ['year'],
            value: value || null,
            format: 'yyyy',
            onChange: function onChange(date) {
              return _this2.onChangeDateValue(column.field, date);
            },
            className: classnames(classes.datepicker, _defineProperty({}, classes.datepickerSlim, slim)),
            keyboardIcon: React.createElement(DateRangeOutlined, {
              fontSize: 'small'
            }),
            mask: '____',
            invalidDateMessage: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B",
            maxDateMessage: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0434 \u043C\u0435\u043D\u044C\u0448\u0435 2100",
            maxDate: new Date('2099-12-31'),
            minDateMessage: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0434 \u0431\u043E\u043B\u044C\u0448\u0435 1900",
            minDate: new Date('1900-01-01'),
            fullWidth: true
          }), !!value && React.createElement(IconButton, {
            onClick: this.onClear(column.field),
            className: classes.datepickerClear
          }, React.createElement(Clear, {
            fontSize: 'small'
          })));
          break;

        case 'select':
          return React.createElement(Select, {
            className: classnames(classes.input, _defineProperty({}, classes.inputSlim, slim)),
            classes: {
              select: classnames(_defineProperty({}, classes.inputNativeSlim, slim))
            },
            value: value,
            onChange: this.onChangeSelectValue(column),
            name: column.field
          }, React.createElement(MenuItem, {
            value: '',
            dense: true
          }, "\u041D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E"), column.values && column.values.map(function (value, index) {
            return React.createElement(MenuItem, {
              key: "select-".concat(value.value, "-").concat(index),
              dense: true,
              value: value.value
            }, value.label);
          }));
          break;

        case 'multiSelect':
          {
            var _classnames10;

            if (!value || !isArray(value)) {
              value = [];
            }

            var isValue = !!value && !!value.length;
            return React.createElement(Select, {
              className: classnames(classes.input, (_classnames10 = {}, _defineProperty(_classnames10, classes.selectOpen, isValue), _defineProperty(_classnames10, classes.inputSlim, slim), _classnames10)),
              classes: {
                select: classnames(_defineProperty({}, classes.inputNativeSlim, slim))
              },
              value: value,
              open: selectOpen === column.field,
              onChange: this.onChangeSelectValue(column),
              onClose: function onClose(_event) {
                return _this2.selectHide();
              },
              onOpen: function onOpen(_event) {
                return _this2.selectOpen(column.field);
              },
              name: column.field,
              multiple: true,
              input: React.createElement(Input, null),
              endAdornment: React.createElement(InputAdornment, {
                position: 'end'
              }, isValue && React.createElement(IconButton, {
                size: 'small',
                onClick: this.onClear(column.field)
              }, React.createElement(CloseIcon, {
                size: 18
              })))
            }, column.values && column.values.map(function (value, index) {
              return React.createElement(MenuItem, {
                key: "select-".concat(value.value, "-").concat(index),
                dense: true,
                value: value.value
              }, value.label);
            }));
            break;
          }

        case 'autocomplete':
          {
            if (!value || !isArray(value)) {
              value = [];
            }

            return React.createElement(Autocomplete, {
              options: column.values,
              value: value,
              onChange: function onChange(event) {
                return _this2.onChangeReactSelect(column, event);
              },
              slim: slim
            });
            break;
          }

        case 'autocompleteMultiple':
          {
            if (!value || !isArray(value)) {
              value = [];
            }

            return React.createElement(Autocomplete, {
              options: column.values,
              value: value,
              onChange: function onChange(event) {
                return _this2.onChangeReactSelect(column, event);
              },
              isMulti: true,
              slim: slim
            });
            break;
          }

        case 'number':
          return React.createElement(Input, {
            type: 'number',
            value: value,
            margin: 'none',
            fullWidth: true,
            onChange: this.onChangeFilterValue(column),
            onKeyPress: this.onEnter,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            className: classnames(classes.input, _defineProperty({}, classes.inputSlim, slim)),
            classes: {
              input: classnames(_defineProperty({}, classes.inputNativeSlim, slim))
            },
            name: column.field,
            endAdornment: React.createElement(InputAdornment, {
              position: 'end'
            }, !!value && React.createElement(IconButton, {
              size: 'small',
              onClick: this.onClear(column.field)
            }, React.createElement(CloseIcon, {
              size: 18
            })))
          });
          break;

        default:
          return React.createElement(Input, {
            value: value,
            margin: 'none',
            fullWidth: true,
            onChange: this.onChangeFilterValue(column),
            onKeyPress: this.onEnter,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            className: classnames(classes.input, _defineProperty({}, classes.inputSlim, slim)),
            classes: {
              input: classnames(_defineProperty({}, classes.inputNativeSlim, slim))
            },
            name: column.field,
            endAdornment: React.createElement(InputAdornment, {
              position: 'end'
            }, !!value && React.createElement(IconButton, {
              size: 'small',
              onClick: this.onClear(column.field)
            }, React.createElement(CloseIcon, {
              size: 18
            })))
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          classes = _this$props7.classes,
          hideFilter = _this$props7.hideFilter;
      return React.createElement("thead", {
        className: classes.thead
      }, this.renderHeadTitle(), !hideFilter && this.renderHeadFilter());
    }
  }]);

  return GridHead;
}(React.Component);

export default GridHead;